import { useEffect, useState } from "react";
const tourCards = [
  {
    title: "Yala National Park",
    subtitle: "Wildtiere und die Wunder der Natur",
    summary: "Der Yala National Park ist der beliebteste Nationalpark Sri Lankas und bekannt f\xFCr seine au\xDFergew\xF6hnliche Artenvielfalt.",
    details: "Der Yala National Park ist der beliebteste Nationalpark Sri Lankas und bekannt f\xFCr seine au\xDFergew\xF6hnliche Artenvielfalt. Neben Krokodilen, Elefanten, Mangusten und niedlichen Affen ist die dichte Population der Leoparden der gr\xF6\xDFte Star dieses Parks. D\xFCnen, Lagunen, eine atemberaubend sch\xF6ne K\xFCste, bizarre Felsformationen, die \xFCber Jahrtausende von Wasser geformt wurden, und vielf\xE4ltige B\xE4ume schaffen eine Landschaft, die Besucher \xFCberw\xE4ltigt. Diese dramatische Kulisse, die Touristen ebenso fasziniert wie Einheimische, bleibt f\xFCr immer in Erinnerung.",
    duration: "Dauer: ca. 4 Stunden je Richtung (1-Nacht-2-Tage-Plan empfohlen)",
    price: "Preis: 195 USD (ca. 25.000 LKR)",
    image: "/images/tours/wildlife-in-yala-national-park_63578.webp",
    alt: "Wildtiere im Yala National Park",
    badge: "Safari"
  },
  {
    title: "Vegetable Market",
    subtitle: "Lokaler Gem\xFCsemarkt",
    summary: "Ein lebendiger Markt mit farbenfrohen Fr\xFCchten, Gem\xFCse, aromatischen Kr\xE4utern und Gew\xFCrzen aus der Region.",
    details: "Farbenfrohe Fr\xFCchte und Gem\xFCse aus der Region, aromatische Kr\xE4uter und Gew\xFCrze \u2013 ein Marktbesuch ist weit mehr als nur Einkaufen, sondern eine aufregende Erfahrung, die die Fruchtbarkeit des Landes und das warme Leben der Menschen sp\xFCrbar macht. Auf dem Markt lebt der Alltag Sri Lankas. Erleben Sie eine besondere lokale Erfahrung, die alle Sinne anspricht und die lokale K\xFCche hautnah erleben l\xE4sst.",
    duration: "Verf\xFCgbarkeit: Dienstag in der N\xE4he des Resorts (ca. 5 Minuten mit dem Auto), Montag auf einem anderen lokalen Markt (ca. 20 Minuten mit dem Auto)",
    price: "Lokale Erfahrung",
    image: "/images/73237152-colombo-sri-lanka-december-6-2016-the-vegetable-stall-of-fose-market-in-pettah-with-wide-range.webp",
    alt: "Lokaler Gem\xFCsemarkt",
    badge: "Local"
  },
  {
    title: "Udawalawe National Park",
    subtitle: "Paradies aus Natur und Wildtieren",
    summary: "Der Udawalawe National Park im S\xFCden des Zentralhochlands ist ein Paradies f\xFCr Wildtiere in ihrer nat\xFCrlichen Umgebung.",
    details: "Der Udawalawe National Park liegt im S\xFCden des Zentralhochlandes von Sri Lanka und ist ein Ort, an dem man exotische Tiere in freier Wildbahn beobachten kann. Rund um einen gro\xDFen Stausee, der 1972 fertiggestellt wurde, sch\xFCtzt ein ausgedehntes Naturgebiet von etwa 30.000 Hektar eine erstaunlich vielf\xE4ltige Tier- und Pflanzenwelt. Hier k\xF6nnen wir Affen, B\xFCffel, Eidechsen, Krokodile und zahlreiche Vogelarten in ihrer nat\xFCrlichen Umgebung beobachten. Der gr\xF6\xDFte H\xF6hepunkt sind die wilden Elefanten. Ihre kraftvollen Bewegungen beim Baden oder beim sozialen Miteinander hinterlassen bei Naturfreunden ein tiefes Gef\xFChl der Bewunderung.",
    duration: "Dauer: Tagesausflug (Fahrt: ca. 4 Stunden je Richtung)",
    price: "Preis: 155 USD (ca. 20.000 LKR)",
    image: "/images/Drive Ceylon/udawalawe/istockphoto-2155402343-612x612.webp",
    alt: "Wildtiere im Udawalawe National Park",
    badge: "Wildlife"
  },
  {
    title: "Turtle Farm",
    subtitle: "Meeresschildkr\xF6ten sch\xFCtzen und in die weite See entlassen",
    summary: "Die Schildkr\xF6tenfarm in Kosgoda ist eine historische Einrichtung zum Schutz gef\xE4hrdeter Meeresschildkr\xF6ten.",
    details: "Die Schildkr\xF6tenfarm in Kosgoda ist eine der traditionsreichsten Schutzstationen Sri Lankas. Seit ihrer Gr\xFCndung im Jahr 1979 arbeitet sie gemeinsam mit staatlichen Schutzbeh\xF6rden, Umweltorganisationen und Wissenschaftlern daran, Meeresschildkr\xF6ten zu sch\xFCtzen, die vom Aussterben bedroht sind. Hier werden nicht nur verletzte Schildkr\xF6ten behandelt, sondern auch frisch geschl\xFCpfte Jungtiere in den ersten Lebenswochen gesch\xFCtzt und unterst\xFCtzt, damit sie sicher in die See zur\xFCckkehren k\xF6nnen. Die Eintrittsgelder unterst\xFCtzen diese wichtigen Schutzma\xDFnahmen. Besuchen Sie die Farm und erleben Sie eine herzliche, sinnvolle Zeit, in der Sie die Bedeutung des Lebens sp\xFCren.",
    duration: "Anfahrt: ca. 30 Minuten mit dem Auto nach Kosgoda",
    price: "Preis: 23 USD (ca. 3.000 LKR)",
    image: "/images/Drive Ceylon/turtle/istockphoto-1170317746-612x612.webp",
    alt: "Meeresschildkr\xF6ten in der Schildkr\xF6tenfarm",
    badge: "Conservation"
  },
  {
    title: "Sigiriya",
    subtitle: "Festung des Himmels, gepr\xE4gt von der Geschichte eines K\xF6nigs",
    summary: "Das kulturelle Erbe Sri Lankas, Sigiriya, gilt als eines der beeindruckendsten Monumente der Welt.",
    details: "Das kulturelle Erbe Sri Lankas, Sigiriya, gilt bei den Einheimischen als das \u201Eachte Weltwunder\u201C. Aus dem gr\xFCnen Dschungel ragt der Felsen Lion Rock in einer H\xF6he von 200 Metern auf, auf dessen Spitze einst ein palastartiges K\xF6nigreich verborgen war. Im Jahr 473 n. Chr. errichtete K\xF6nig Kassapa, der nach einem Thronfolgekrieg seinen Vater t\xF6tete, auf diesem Felsen ein K\xF6nigspalast, um seinen Machtanspruch zu symbolisieren. Die farbenfrohen Fresken der Frauen von Sigiriya an den Felsw\xE4nden erz\xE4hlen von der hohen Kunst und Kultur der damaligen Zeit. Von der Spitze der steilen Treppe aus er\xF6ffnet sich ein grandioses Panorama des Dschungels bis zum Horizont.",
    duration: "Dauer: ca. 5 Stunden je Richtung (kombinierbar mit Dambulla)",
    price: "Preis: 194 USD (ca. 25.000 LKR)",
    image: "/images/tours/Sigiriya-Sri-Lanka-5-2.jpg.webp",
    alt: "Fels von Sigiriya",
    badge: "Heritage"
  },
  {
    title: "Richmond Castle",
    subtitle: "Eine pr\xE4chtige Residenz, die Erinnerungen an eine vergangene \xC4ra bewahrt",
    summary: "Eine der pr\xE4chtigsten Bauwerke Sri Lankas, errichtet zu Beginn des 20. Jahrhunderts.",
    details: "Das Richmond Castle in der N\xE4he von Kalutara ist eines der pr\xE4chtigsten Bauwerke Sri Lankas, das zu Beginn des 20. Jahrhunderts erbaut wurde. Das zweigeschossige Herrenhaus, einst von einem wohlhabenden Mudali (h\xF6her Beamter in der Kolonialzeit) errichtet, ist durch elegante Designs gepr\xE4gt, die den Stil der indischen Maharaja-Pal\xE4ste widerspiegeln. Das beeindruckende Geb\xE4ude mit 34 Fenstern und 99 T\xFCren bewahrt heute die Erinnerung an eine glanzvolle Vergangenheit. Bei der F\xFChrung durch das Haus erfahren Sie von der turbulenten Lebensgeschichte des Besitzers und interessanten Episoden aus jener Zeit. Heute dient es auch als Bildungseinrichtung f\xFCr Waisenkinder, und dieser edle Geist wird weitergef\xFChrt.",
    duration: "Anfahrt: ca. 25 Minuten mit dem Auto vom Resort",
    price: "Preis: 20 USD (ca. 2.500 LKR)",
    image: "/images/richmond-castle-at-palatota.webp",
    alt: "Richmond Castle",
    badge: "Culture"
  },
  {
    title: "Moonstone Mine",
    subtitle: "Der einzige Ort der Welt, an dem der mystische Stein entsteht",
    summary: "In Meetiyagoda befindet sich die seltene Mine, in der Mondsteine abgebaut werden \u2013 die einzige ihrer Art weltweit.",
    details: "Meetiyagoda ist als die weltweit einzige Mine bekannt, in der Mondsteine abgebaut werden. Hier k\xF6nnen Sie die Kunst der traditionellen Verarbeitung hautnah erleben. Sie k\xF6nnen den gesamten Prozess beobachten \u2013 von der Bergbauarbeit in den tiefen Stollen bis zur sorgf\xE4ltigen Verarbeitung des Rohmaterials zu wundersch\xF6nem Schmuck durch erfahrene Handwerker. Die Handwerker erkl\xE4ren jeden Schritt detailreich, und Sie k\xF6nnen Mondsteine aus der Region als pers\xF6nliche Freude oder Geschenk f\xFCr besondere Menschen erwerben.",
    duration: "Anfahrt: ca. 1 Stunde mit dem Auto",
    price: "Preis: 46 USD (ca. 6.000 LKR)",
    image: "/images/mondsteinmine.webp",
    alt: "Mondsteinmine",
    badge: "Craft"
  },
  {
    title: "Matugama",
    subtitle: "Sinhalesische Landwirtschaft und ein authentisches lokales Leben",
    summary: "Eine ruhige lokale Tour mit Reisfeldern, Plantagen und Wasserf\xE4llen.",
    details: "Auf dieser Tour sehen Sie endlose Reisfelder, Kokosnuss-, Gummi- und Teeplantagen, und entlang der Strecke besuchen Sie auch wundersch\xF6ne Wasserf\xE4lle. Matugama liegt im Landesinneren und ist eine der wichtigsten St\xE4dte in der N\xE4he des Resorts. Hier, fern von Massentourismus, erleben Sie die vielf\xE4ltige Natur Sri Lankas und das warme t\xE4gliche Leben seiner Menschen. Genie\xDFen Sie eine ruhige und ruhige Zeit, in der Sie das wahre Gesicht Sri Lankas entdecken.",
    duration: "Anfahrt: ca. 30 Minuten mit dem Auto vom Resort",
    price: "Preis: 38 USD (ca. 5.000 LKR)",
    image: "/images/images.webp",
    alt: "Landwirtschaftslandschaft in Matugama",
    badge: "Local"
  },
  {
    title: "Madu River",
    subtitle: "Bootsfahrt bei Sonnenaufgang durch Mangrovenwald und heilige Inseln",
    summary: "Eine Bootsfahrt im fr\xFChen Morgenlicht durch Mangroven und Inseln.",
    details: "Bei Sonnenaufgang fahren Sie mit dem Boot den Madu-Fluss hinunter. Unter der F\xFChrung eines Guides durchqueren Sie Mangrovenpassagen und besuchen Inseln im See. Sie besichtigen den Kothduwa-Tempel und lernen auf der Cinnamon Island die traditionelle Zubereitung von frischem Zimttee kennen. Wenn Sie Gl\xFCck haben, beobachten Sie Affen, Eisv\xF6gel oder Eidechsen im Mangrovenwald.",
    duration: "Anfahrt: 45 Minuten mit dem Auto nach Balapitiya",
    price: "Preis: 62 USD (ca. 8.000 LKR)",
    image: "/images/Madu-River-Safari-03.webp",
    alt: "Bootstour am Madu River",
    badge: "Nature"
  },
  {
    title: "Lunuganga",
    subtitle: "Ein Paradies, das K\xFCnstler liebten",
    summary: "Ein tropisches Paradies, das der Architekt Geoffrey Bawa \xFCber viele Jahre gestaltet hat.",
    details: "Geoffrey Bawa, einer der weltweit bekanntesten Architekten Sri Lankas, verwandelte \xFCber 40 Jahre lang einen verlassenen Kautschukgarten in ein tropisches Paradies. Die Landschaft, gepflegt von 40 G\xE4rtnern und 12 Mitarbeitern, bietet eine atemberaubende Aussicht auf den Dedduwa-See und den Bentota-Fluss. Die Sch\xF6nheit der Natur und die liebevoll gestalteten G\xE4rten ber\xFChren Besucher auf ruhige und tief empfundene Weise.",
    duration: "Fahrzeit: ca. 30 Minuten mit dem Auto vom Resort",
    price: "Preis: 21 USD (ca. 2.700 LKR)",
    image: "/images/lunuganga_01.webp",
    alt: "G\xE4rten von Lunuganga",
    badge: "Design"
  },
  {
    title: "Lighthouse Island",
    subtitle: "Leuchtturm im Blau des Meeres",
    summary: "Eine entspannte Exkursion mit einer Bootsfahrt zu einer kleinen Insel in Bentota.",
    details: "Fr\xFCher ein kleines Fischerdorf, ist Bentota heute ber\xFChmt f\xFCr feine Sandstr\xE4nde, kristallklares Wasser und einen wei\xDFen Leuchtturm, der von Palmen umgeben ist. Die Bootsfahrt zur Insel f\xFChrt zu einer atemberaubenden Landschaft, die den Alltag vergessen l\xE4sst. Genie\xDFen Sie die angenehme Brise und die ruhige Zeit am Fu\xDFe des historischen Leuchtturms. Das klare Wasser und die blaue Luft bringen tiefen Frieden in die Seele.",
    duration: "Fahrzeit: ca. 20 Minuten mit dem Boot",
    price: "Preis: 38 USD (ca. 5.000 LKR)",
    image: "/images/images (1).webp",
    alt: "Lighthouse Island",
    badge: "Sea"
  },
  {
    title: "Kataragama",
    subtitle: "Ein Ort, an dem heilige Gebete zusammenflie\xDFen",
    summary: "Ein spiritueller Ort im S\xFCden, an dem verschiedene Glaubensrichtungen still und in Frieden zusammenkommen.",
    details: "Kataragama im S\xFCden Sri Lankas ist einer der heiligsten Pilgerorte. Der Ort ist nach dem Gott benannt, dem er gewidmet ist. Buddhisten, Hindus, Muslime und die eingeborene Vedda-Gemeinschaft verehren hier gemeinsam an demselben heiligen Ort und respektieren einander. Die bunten Opfergaben, die Klangwelt der Rituale und die Atmosph\xE4re des Gebets schaffen ein tiefes Gef\xFChl spiritueller Ruhe und einer jahrhundertealten, stillen Lebendigkeit.",
    duration: "Fahrzeit: ca. 4 Stunden mit dem Auto (ideal kombinierbar mit dem Yala National Park)",
    price: "Preis: 195 USD (ca. 25.000 LKR)",
    image: "/images/images (2).webp",
    alt: "Pilgerort Kataragama",
    badge: "Spiritual"
  },
  {
    title: "Kandy",
    subtitle: "Heilige alte Hauptstadt in den Bergen",
    summary: "Eine kulturelle Stadt in Zentral-Sri Lanka mit Zahnreliquie, Bergen, See und botanischen G\xE4rten.",
    details: "Kandy ist eine gro\xDFe Stadt im zentralen Bergland Sri Lankas. Das Symbol der Stadt ist der Tempel der Zahnreliquie, der seit dem 4. Jahrhundert eine heilige Bedeutung hat. Auch das riesige Buddha-Standbild auf dem Berg Bahirawakanda, das in den 1990er Jahren errichtet wurde, ist von vielen Punkten der Stadt aus sichtbar. Ruhiger Kandy-See, ausgedehnte botanische G\xE4rten und reiche Schutzgebiete machen diese Stadt zu einem wahren Ort der Sch\xF6nheit und des kulturellen Erbes.",
    duration: "Fahrzeit: ca. 4 Stunden mit dem Auto (empfohlen f\xFCr Reisen mit 1 Nacht und 2 Tagen oder l\xE4nger)",
    price: "Preis: 155 USD (ca. 20.000 LKR)",
    image: "/images/Drive Ceylon/kandy/pexels-freestockpro-322437.webp",
    alt: "Tempellandschaft in Kandy",
    badge: "Heritage"
  },
  {
    title: "Kalutara",
    subtitle: "Gro\xDFe wei\xDFe Stupa und heilige Bodhi, die Spiritualit\xE4t erz\xE4hlen",
    summary: "Eine ruhige Kulturreise zum Gangathivaka Viharaya-Tempel.",
    details: "Eine Reise zum beeindruckenden Gangathivaka Viharaya-Tempel. Im Inneren des Tempels befindet sich eine wertvolle Dagoba, eine wei\xDFe runde Kuppel, die in Sri Lanka einzigartig ist und von au\xDFen besonders auff\xE4llt. Der Tempel ist ein heiliger Pilgerort, der von gl\xE4ubigen Buddhisten verehrt wird. Auf dem Gel\xE4nde steht zudem eine heilige Bodhi, die nach Tradition 2.000 Jahre alt sein soll und an den Ort erinnert, an dem der Buddha die Erleuchtung erlangte.",
    duration: "Fahrzeit: ca. 20 Minuten mit dem Auto",
    price: "Preis: 20 USD (ca. 2.500 LKR)",
    image: "/images/images (3).webp",
    alt: "Tempel in Kalutara",
    badge: "Temple"
  },
  {
    title: "Galle",
    subtitle: "UNESCO-Weltkulturerbe mit europ\xE4ischem Flair",
    summary: "Die Festung Galle wurde 1663 von den Niederl\xE4ndern errichtet und ist heute ein UNESCO-Weltkulturerbe.",
    details: "Die Festung Galle, die 1663 von den Niederl\xE4ndern errichtet wurde, wurde als UNESCO-Weltkulturerbe eingetragen. Sie ist die besterhaltene europ\xE4ische Festung S\xFCdasiens und zeigt eine perfekte Verbindung europ\xE4ischer und asiatischer Architekturstile. Die Kathedrale St. Mary, ein Symbol der Stadt, ist ein Muss. Von hier aus genie\xDFen Sie einen herrlichen Ausblick auf den blauen Ozean, den wei\xDFen Leuchtturm und den historischen Hafen. Spazierg\xE4nge \xFCber Steinwege schaffen eine nostalgische und elegante Atmosph\xE4re.",
    duration: "Fahrzeit: ca. 1 Stunde mit dem Auto",
    price: "Preis: 73 USD (ca. 9.500 LKR)",
    image: "/images/tours/Why-Galle-Fort-Is-a-Must-Visit-Day-Trip-from-Unawatuna-1050x700-1.webp",
    alt: "Stadtbild der Festung Galle",
    badge: "Heritage"
  },
  {
    title: "Fish Market",
    subtitle: "Einblick in das lebendige Alltagsleben in Bentota",
    summary: "Der Fischmarkt am fr\xFChen Morgen in Bentota zeigt das t\xE4gliche Leben der Insel und ihre gro\xDFe Lebensenergie.",
    details: "Am fr\xFChen Morgen \xF6ffnet der lokale Fischmarkt in Bentota. \xDCber die St\xE4nde verteilt liegen frisch gefangene Fische wie Hai, Rochen, Red Snapper, Thunfisch und verschiedene Krebstiere. In der lebendigen Morgenstimmung erleben Sie die Lebensweise der Menschen in Sri Lanka und die reiche Lebensenergie der Insel.",
    duration: "Fahrzeit: ca. 15 Minuten mit dem Auto (t\xE4glich fr\xFCh am Morgen)",
    price: "Lokale Erfahrung",
    image: "/images/fischmarkt_01.webp",
    alt: "Fischmarkt in Bentota",
    badge: "Local"
  },
  {
    title: "Dambulla",
    subtitle: "Heilige H\xF6hlen, gesch\xFCtzt von goldenen Tempeln",
    summary: "Eine Stadt nahe Sigiriya, bekannt f\xFCr ihre H\xF6hlentempel und den Goldenen UNESCO-Tempel.",
    details: "Dambulla liegt nahe der beliebten Touristenstadt Sigiriya und bietet viele Highlights. Die gr\xF6\xDFte Tempelanlage des Landes umfasst etwa 80 H\xF6hlen und insgesamt 153 Buddha-Statuen. Au\xDFerdem ist die Stadt ber\xFChmt f\xFCr die gr\xF6\xDFte Rosenglas-Quelle S\xFCdasiens sowie den Namal Uyana-Eisenholzwald. Der farbenfrohe Goldene Tempel, 1991 als UNESCO-Weltkulturerbe anerkannt, ist f\xFCr Kunst- und Kulturliebhaber ein echter H\xF6hepunkt der Reise nach Sri Lanka.",
    duration: "Fahrzeit: ca. 5 Stunden mit dem Auto (f\xFCr Reisen mit 1 Nacht und 2 Tagen oder l\xE4nger empfohlen)",
    price: "Preis: 195 USD (ca. 25.000 LKR)",
    image: "/images/dambulla.webp",
    alt: "Tempel in Dambulla",
    badge: "Heritage"
  },
  {
    title: "Brief Garden",
    subtitle: "Willkommen im gr\xFCnen Labyrinth",
    summary: "Die ehemalige Residenz des Bildhauers Bevis Bawa, ein verborgenes Kleinod aus Natur und Kunst.",
    details: "Brief Garden, die ehemalige Residenz des Bildhauers Bevis Bawa (Bruder von Geoffrey Bawa), \xF6ffnet seit 2006 seinen T\xFCren f\xFCr Natur- und Kunstliebhaber. Der gepflegte Garten und die Residenz sind ein verborgenes Refugium, das noch nicht von Tourismus \xFCberrannt wurde. Sobald Sie eintreten, erwartet Sie ein verwinkeltes Labyrinth aus tropischen Pflanzen, exotischen V\xF6geln und ruhigen Wegen. Der Ort ist still und meditative, ein perfekter Raum zum Entdecken und Nachdenken. Genie\xDFen Sie einen Moment, in dem Sie die k\xFCnstlerische Sensibilit\xE4t Sri Lankas erleben.",
    duration: "Dauer: ca. 5 Minuten (mit dem Auto)",
    price: "Preis: 20 USD (ca. 2.500 LKR)",
    image: "/images/brief_garden_01.webp",
    alt: "G\xE4rten von Brief Garden",
    badge: "Garden"
  },
  {
    title: "Ambalangoda",
    subtitle: "Traditionelle Maskenkultur und ein liegender Buddha von asiatischer Gr\xF6\xDFe",
    summary: "Eine lebhafte Stadt mit buntem liegendem Buddha und einer reichen Maskenkultur.",
    details: "Hier steht eine riesige liegende Buddha-Statue von 50 Metern L\xE4nge, die in Asien ihresgleichen sucht. Die Stadt ist lebendig und attraktiv f\xFCr Shopping und Besichtigungen. Sie ist auch weltweit f\xFCr die traditionelle Maskenkultur Sri Lankas bekannt. Die Masken f\xFCr Volkskunst und Heilungsrituale k\xF6nnen in \xF6rtlichen Museen besichtigt werden und er\xF6ffnen einen Einblick in die tiefe spirituelle Kultur Sri Lankas.",
    duration: "Fahrzeit: ca. 1 Stunde mit dem Auto",
    price: "Preis: 43 USD (ca. 5.500 LKR)",
    image: "/images/ambalangoda.webp",
    alt: "Liegender Buddha in Ambalangoda",
    badge: "Culture"
  },
  {
    title: "Aluthgama",
    subtitle: "Stadt der Barmherzigkeit des Buddha",
    summary: "Eine ruhige Stadt am Fu\xDFe eines heiligen Berges mit einem gro\xDFen Buddha und entspannter Atmosph\xE4re.",
    details: "Wenn Sie Aluthgama betreten, sp\xFCren Sie sofort die ruhige Energie des Buddha. Neben dem heiligen H\xFCgel mit dem Kande Viharaya-Tempel beherrscht eine der gr\xF6\xDFten sitzenden Buddha-Statuen Sri Lankas die Stadt. Zwar bleibt die Atmosph\xE4re noch angenehm unkommerzialisiert, doch es gibt auch gute Shopping-M\xF6glichkeiten. Diese Stadt verbindet ruhiges Gebet mit lebendigem Alltag und zeigt die authentische Sch\xF6nheit Sri Lankas.",
    duration: "Fahrzeit: ca. 20 Minuten mit dem Auto",
    price: "Preis: 20 USD (ca. 2.500 LKR)",
    image: "/images/image015-1040x598.webp",
    alt: "Buddha-Statue in Aluthgama",
    badge: "Temple"
  }
];
const TourLocations = () => {
  const [activeTour, setActiveTour] = useState(null);
  useEffect(() => {
    if (!activeTour) {
      document.body.style.overflow = "auto";
      return;
    }
    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setActiveTour(null);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [activeTour]);
  return <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fffaf2_0%,#ffffff_45%,#f8f5f1_100%)] py-16 sm:py-20 lg:py-28">
            <div className="absolute -left-20 top-10 h-72 w-72 rounded-full bg-amber-200/25 blur-3xl" />
            <div className="absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-emerald-200/20 blur-3xl" />

            <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center">
                    <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-4 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-amber-800 shadow-sm backdrop-blur md:text-sm">
                        Tour-Sammlung
                    </span>

                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Geschichten von Natur und Geschichte an den Reiseziele
                    </h2>

                    <p className="mt-4 font-mulish text-base leading-relaxed text-gray-700 sm:text-lg">
                        Wenn Sie auf einer Karte auf „Mehr erfahren“ klicken, öffnet sich das Detailfenster im Modal.
                    </p>
                </div>

                <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
                    {tourCards.map((tour) => <article
    key={`${tour.title}-${tour.badge}`}
    className="group overflow-hidden rounded-[22px] bg-white shadow-[0_20px_55px_rgba(15,23,42,0.1)] transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_26px_65px_rgba(15,23,42,0.14)]"
  >
                            <div className="relative aspect-[4/3] w-full overflow-hidden">
                                <img
    src={tour.image}
    alt={tour.alt}
    className="object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/18 to-transparent" />


                                <div className="absolute inset-x-0 bottom-0 p-4 text-white">
                                    <p className="font-serif text-xl font-semibold leading-tight">{tour.title}</p>
                                    <p className="mt-1.5 text-sm leading-5 text-white/88">{tour.subtitle}</p>
                                </div>
                            </div>

                            <div className="space-y-3 p-4 sm:p-5">
                                <p className="text-sm leading-6 text-gray-700">{tour.summary}</p>

                                <div className="flex flex-wrap gap-3">
                                    <button
    type="button"
    onClick={() => setActiveTour(tour)}
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-4 py-2 text-sm font-semibold text-[#1f4d3c] shadow-lg shadow-yellow-200/70 transition hover:bg-[#e7b90d]"
  >
                                        Mehr erfahren
                                    </button>
                                </div>
                            </div>
                        </article>)}
                </div>
            </div>

            {activeTour ? <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm" role="dialog" aria-modal="true" aria-label={activeTour.title} onClick={() => setActiveTour(null)}>
                    <div
    className="max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-[32px] border border-white/70 bg-white shadow-[0_30px_100px_rgba(15,23,42,0.35)]"
    onClick={(event) => event.stopPropagation()}
  >
                        <div className="grid grid-cols-1 lg:grid-cols-2">
                            <div className="relative min-h-[280px] lg:min-h-full">
                                <img
    src={activeTour.image}
    alt={activeTour.alt}
    className="object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                            </div>

                            <div className="max-h-[90vh] overflow-y-auto p-6 sm:p-8 lg:p-10">
                                <div className="flex items-start justify-between gap-4">
                                    <div>
                                        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-amber-800">{activeTour.badge}</p>
                                        <h3 className="mt-3 font-serif text-3xl font-semibold leading-tight text-[#1f4d3c] sm:text-4xl">{activeTour.title}</h3>
                                        <p className="mt-3 font-serif text-xl font-medium text-[#24422f]">{activeTour.subtitle}</p>
                                    </div>

                                    <button
    type="button"
    onClick={() => setActiveTour(null)}
    className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-200 text-lg font-semibold text-[#1f4d3c] transition hover:border-[#F28600] hover:text-[#d67000]"
    aria-label="Close details"
  >
                                        ×
                                    </button>
                                </div>

                                <div className="mt-6 space-y-4 text-[15px] leading-8 text-gray-700 sm:text-base">
                                    <p>{activeTour.details}</p>
                                    <p className="font-semibold text-[#1f4d3c]">{activeTour.duration}</p>
                                    <p className="font-semibold text-[#1f4d3c]">{activeTour.price}</p>
                                </div>

                                <div className="mt-8 flex flex-wrap gap-3">
                                    <button
    type="button"
    onClick={() => setActiveTour(null)}
    className="inline-flex items-center justify-center rounded-full bg-[#F3C623] px-6 py-3 text-sm font-semibold text-[#1f4d3c] shadow-lg shadow-yellow-200/70 transition hover:bg-[#e7b90d]"
  >
                                        Schließen
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null}
        </section>;
};
export default TourLocations;
